import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import appConfig from 'app-config';
import { redact } from 'flow/utils/browser-utils';
var E164_PATTERN = /\+\d{7,15}/g;
var scrubItem = function scrubItem(item) {
  var payload = _objectSpread({}, item.payload);
  if (typeof payload['message'] === 'string') {
    payload['message'] = redact(payload['message']);
  }
  if (payload['context'] && _typeof(payload['context']) === 'object') {
    payload['context'] = redact(payload['context']);
  }
  if (typeof payload['value'] === 'string') {
    payload['value'] = redact(payload['value']);
  }
  if (payload['resourceSpans']) {
    var raw = JSON.stringify(payload['resourceSpans']).replace(E164_PATTERN, '[number]');
    payload['resourceSpans'] = JSON.parse(redact(raw));
  }
  return _objectSpread(_objectSpread({}, item), {}, {
    payload: payload
  });
};

// Prod configs always provide a collector URL (default telemetry.telavox.com);
// in dev it is empty unless FARO_COLLECTOR_URL is set, which disables Faro.
var collectorUrl = appConfig.faroCollectorUrl || null;
var _faro = null;
export var getFaro = function getFaro() {
  return _faro;
};
export var initFaro = function initFaro() {
  if (_faro || !collectorUrl) return;
  _faro = initializeFaro({
    url: collectorUrl,
    apiKey: appConfig.telemetryApiKey,
    app: {
      name: appConfig.beta ? 'webclient-beta' : 'webclient',
      version: appConfig.version,
      environment: appConfig.environment
    },
    beforeSend: scrubItem,
    instrumentations: [].concat(_toConsumableArray(getWebInstrumentations({
      captureConsole: true
    })), [new TracingInstrumentation()])
  });
};